import { render, staticRenderFns } from "./content-double-image.vue?vue&type=template&id=3bcaca0d&scoped=true&lang=html"
import script from "./content-double-image.vue?vue&type=script&lang=js"
export * from "./content-double-image.vue?vue&type=script&lang=js"
import style0 from "./content-double-image.vue?vue&type=style&index=0&id=3bcaca0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcaca0d",
  null
  
)

export default component.exports